
export const validRoutesByUser = {
  superUser: ['SupportAgent'],
  supportAgent: ['Patient', 'Client', 'Clinician', 'ChangeLog', 'Invite', 'ZBEdgeUser'],
  supportManager: ['SupportAgent'],
}
